"use client";
import {
  useCompositeStoreProps
} from "./7GBW5FLS.js";
import {
  useStore,
  useStoreProps
} from "./EKQEJRUF.js";
import {
  useUpdateEffect
} from "./6O5OEQGF.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/tab/tab-store.ts
import { useMemo } from "react";
import * as Core from "@ariakit/core/tab/tab-store";
function useTabStoreProps(store, update, props) {
  store = useCompositeStoreProps(store, update, props);
  useStoreProps(store, props, "selectedId", "setSelectedId");
  useStoreProps(store, props, "selectOnMove");
  const [panels, updatePanels] = useStore(() => store.panels, {});
  useUpdateEffect(updatePanels, [store, updatePanels]);
  return useMemo(() => __spreadProps(__spreadValues({}, store), { panels }), [store, panels]);
}
function useTabStore(props = {}) {
  const [store, update] = useStore(Core.createTabStore, props);
  return useTabStoreProps(store, update, props);
}

export {
  useTabStoreProps,
  useTabStore
};
